import { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTooltip } from 'src/components/CustomTooltip';

import { useStyles } from './useStyles';

export const ResourceThumbnailTooltip = ({
  classes,
  thumbnailUrl,
  onClick,
  label,
  children,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  const [imageLoaded, setImageLoaded] = useState(false);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (!thumbnailUrl && !label) {
    return children;
  }

  return (
    <CustomTooltip
      classes={{ tooltip: styles.tooltip }}
      title={
        <div className={styles.title}>
          {thumbnailUrl && (
            <img
              className={cx(styles.image, {
                [styles.loaded]: imageLoaded,
              })}
              src={thumbnailUrl}
              onLoad={handleImageLoad}
            />
          )}

          <ButtonText
            className={styles.buttonLabel}
            onClick={onClick}
          >
            {label}
          </ButtonText>
        </div>
      }
      arrow={false}
      interactive
      {...restProps}
    >
      {children}
    </CustomTooltip>
  );
};

ResourceThumbnailTooltip.displayName = 'ResourceThumbnailTooltip';
ResourceThumbnailTooltip.propTypes = {
  classes: PropTypes.shape(),
  thumbnailUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};
ResourceThumbnailTooltip.defaultProps = {
  classes: null,
  thumbnailUrl: null,
  label: null,
};
